import React, { useState, useEffect } from 'react';
import moment from 'moment';

const WeekDropDown = ({ onWeekChange }) => {
  const [weeks, setWeeks] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState(-1); // Default to -1 for the disabled option

  useEffect(() => {
    const generateWeeks = () => {
      const startOfYear = moment().startOf('year');
      const endOfYear = moment().endOf('year');
      const now = moment();
      const threeMonthsLater = now.add(3, 'months'); 
      const weekArray = [];
      const today = moment().startOf('day');

      let currentWeekStart = startOfYear.clone().startOf('isoWeek');

      while (currentWeekStart.isBefore(threeMonthsLater)) {
        // Only add weeks that are today or in the future
        if (currentWeekStart.isSameOrAfter(today)) {
          const weekEnd = currentWeekStart.clone().endOf('isoWeek');
          const weekLabel = `${currentWeekStart.format('dddd, MMM DD')} - ${weekEnd.format('dddd, MMM DD')} ${currentWeekStart.year()}`;
          weekArray.push({ label: weekLabel, start: currentWeekStart.toDate(), end: weekEnd.toDate() });
        }
        currentWeekStart.add(1, 'week');
      }

      setWeeks(weekArray);
    };

    generateWeeks();
  }, []);

  const handleWeekChange = (event) => {
    const selectedIndex = parseInt(event.target.value);
    const week = weeks[selectedIndex];
    setSelectedWeek(selectedIndex);
    onWeekChange(week); // Notify parent about the selected week
  };

  return (
    <select id="week" value={selectedWeek} onChange={handleWeekChange}>
      <option value={-1} disabled>Select a week</option>
      {weeks.map((week, index) => (
        <option key={index} value={index}>
          {week.label}
        </option>
      ))}
    </select>
  );
};

export default WeekDropDown;
